var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
var MediaService = services.MediaService, BuildService = services.BuildService;
export var fetchPlatformVersion = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, version, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: 'APP_BUILD_PLATFORM_VERSION_REQUEST' });
                return [4 /*yield*/, BuildService.version()];
            case 1:
                _a = (_b.sent()).object, version = _a === void 0 ? { major: 0, minor: 0, patch: 0 } : _a;
                dispatch({ type: 'APP_BUILD_PLATFORM_VERSION_SUCCESS', version: version });
                return [3 /*break*/, 3];
            case 2:
                err_1 = _b.sent();
                console.error(err_1);
                dispatch({ type: 'APP_BUILD_PLATFORM_VERSION_FAIL' });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var fetchBuilds = function (appId, version) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, builds, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch({ type: 'APP_BUILD_FETCH_REQUEST' });
                    return [4 /*yield*/, BuildService.listByVersion(appId, version)];
                case 1:
                    _a = (_b.sent()).objects, builds = _a === void 0 ? [] : _a;
                    dispatch({ type: 'APP_BUILD_FETCH_SUCCESS', builds: builds });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _b.sent();
                    console.error(err_2);
                    dispatch({ type: 'APP_BUILD_FETCH_FAIL' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchDownloadLink = function (buildId, duration) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var object, downloadLink, expiry, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'APP_BUILD_DOWNLOAD_LINK_REQUEST' });
                    return [4 /*yield*/, BuildService.getDownloadLink(buildId, duration)];
                case 1:
                    object = (_a.sent()).object;
                    if (object) {
                        downloadLink = object.download_link, expiry = object.expiry;
                        if (downloadLink) {
                            dispatch({
                                type: 'APP_BUILD_DOWNLOAD_LINK_SUCCESS',
                                downloadLink: downloadLink,
                                expiry: expiry,
                            });
                            return [2 /*return*/];
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _a.sent();
                    console.error(err_3);
                    return [3 /*break*/, 3];
                case 3:
                    dispatch({ type: 'APP_BUILD_DOWNLOAD_LINK_FAIL' });
                    return [2 /*return*/];
            }
        });
    }); };
};
export var fetchErrorLog = function (buildId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var errorMsg, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'APP_BUILD_ERROR_LOG_RESET' });
                dispatch({ type: 'APP_BUILD_ERROR_LOG_REQUEST' });
                return [4 /*yield*/, BuildService.getErrorLog(buildId)];
            case 1:
                errorMsg = (_a.sent()).object.usrErrString;
                dispatch({
                    type: 'APP_BUILD_ERROR_LOG_SUCCESS',
                    errorMsg: errorMsg,
                });
                return [3 /*break*/, 3];
            case 2:
                err_4 = _a.sent();
                console.error(err_4);
                return [3 /*break*/, 3];
            case 3:
                dispatch({ type: 'APP_BUILD_ERROR_LOG_FAIL' });
                return [2 /*return*/];
        }
    });
}); }; };
export var retryBuild = function (app, platform, version, buildNumber, meta) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: 'APP_BUILD_RETRY_REQUEST' });
                    return [4 /*yield*/, BuildService.request(app, platform, version, buildNumber, meta)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetchBuilds(app, version || '')(dispatch)];
                case 2:
                    _a.sent();
                    dispatch({ type: 'APP_BUILD_RETRY_SUCCESS' });
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _a.sent();
                    console.error(err_5);
                    if (err_5 && err_5.status === 409) {
                        dispatch({ type: 'APP_BUILD_RETRY_CONFLICT' });
                        return [2 /*return*/];
                    }
                    dispatch({ type: 'APP_BUILD_RETRY_FAIL' });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var loadPublishedDates = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var publishedDates, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'APP_PUBLISHED_DATES_REQUEST' });
                return [4 /*yield*/, BuildService.getPublishedDates(appId)];
            case 1:
                publishedDates = (_a.sent()).object;
                dispatch({ type: 'APP_PUBLISHED_DATES_SUCCESS', publishedDates: publishedDates });
                return [3 /*break*/, 3];
            case 2:
                err_6 = _a.sent();
                console.error(err_6);
                dispatch({ type: 'APP_PUBLISHED_DATES_FAIL' });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var checkImageAvailable = function (appId, iOSLastIcon, androidLastIcon) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var files, isIOSAvailable, isAndroidAvailable;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MediaService.getFiles("app:".concat(appId, ":build"))];
            case 1:
                files = (_a.sent()).objects;
                isIOSAvailable = Boolean(files.find(function (file) {
                    return "".concat(process.env.MEDIA_BUCKET_URL, "/").concat(file.external_id) === iOSLastIcon;
                }));
                isAndroidAvailable = Boolean(files.find(function (file) {
                    return "".concat(process.env.MEDIA_BUCKET_URL, "/").concat(file.external_id) ===
                        androidLastIcon;
                }));
                return [2 /*return*/, {
                        iOS: isIOSAvailable,
                        android: isAndroidAvailable,
                    }];
        }
    });
}); }; };
